<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>类型名称：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入类型名称"/>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="areaIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in areaOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" type="index" width="50px"/>
          <el-table-column prop="typeName" label="类型名称" align="center"/>
          <el-table-column prop="remark" label="备注" align="center"/>
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="280" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button v-if="scope.row.status" size="mini" type="danger" @click="disableClick(scope.row.id)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情委托商类型" :visible.sync="detailDialogVisible" width='550px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p :style="getStyle(detailData.status)">{{getState(detailData.status)}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">类型名称：</span>
              <span>{{detailData.typeName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">备注：</span>
              <span>{{detailData.remark}}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='550px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="company">
        <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
          <el-form-item label="类型名称：" prop="name">
            <el-input
              :style="'width:100%'"
              v-model="companyData.name"
              placeholder="请输入类型名称"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              type="textarea"
              style="width:100%;margin-bottom: 15px;"
              v-model="companyData.remark"
              placeholder="请输入备注"
              autocomplete="off"
              size="mini"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <div class="btnContainer">
            <el-button class="searchBtn" size="medium" :loading="addLoad" @click="addClick">确认</el-button>
            <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {formatDateTime, removeSpace} from "@/config/mUtils";
import {
  customerTypePageList,
  customerTypeIsEnable,
  customerTypeDelete,
  customerTypeDetail,
  customerTypeAdd,
  customerTypeUpdate,
} from "@/service/basicfile";

export default {
  components: {
  },
  data() {
    return {
      nameIpt:'',
      areaIpt:'',
      areaOption:[
        {value:'',label:'全部',},
        {value:1,label:'启用中'},
        {value:0,label:'禁用中'},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      addLoad:false,
      detailData:{},
      operationData:[],
      dialogTitle:'',
      dialogVisible:false,
      companyData:{
        name:'',
        remark:'',
      },
      areaOption1:[
        {value:'重庆市-渝北区',label:'重庆市-渝北区'},
        {value:'重庆市-九龙坡区',label:'重庆市-九龙坡区'},
      ],
      unitOption:[
        {value:0,label:'天'},
        {value:1,label:'时'},
      ],
      rules:{
        name:[
          { required: true, message: '请输入类型名称', trigger: 'blur' },
        ],
      },
    };
  },
  computed:{
    getStyle() {
      return (val) => {
        switch (val) {
          case 1:
            return 'color: rgba(51, 84, 131, 100);'
          case 0:
            return 'color:#F56C6C;'
        }
      }
    },
    getState(){
      return function(state){
        switch(state) {
          case 0:
            return '禁用中'
          case 1:
            return '启用中'
        }
      };
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
  },
  mounted() {
    this._customerTypePageList();
  },
  methods: {
    async _customerTypePageList(){
      this.tableLoad=true;
      const obj = {
        typeName:this.nameIpt,
        status:this.areaIpt,
        rows:this.size,
        page:this.page,
      };
      const res = await customerTypePageList(obj);
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._customerTypePageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._customerTypePageList();
    },
    disableClick(id){
      this.$confirm('确定要禁用当前委托商类型吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await customerTypeIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._customerTypePageList();
      }).catch(() => {});
    },
    async detailClick(id) {
      const res = await customerTypeDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.operationData=res.data.operateRecordList;
      this.detailData={
        ...res.data,
      };
      this.detailDialogVisible = true;
    },
    deleteClick(id){
      this.$confirm('确定要删除当前类型吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await customerTypeDelete(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._customerTypePageList();
      }).catch(() => {});
    },
    changeClick(item){
      this.companyData={
        ...item,
        name:item.typeName,
        remark:item.remark,
      };
      this.dialogTitle='修改委托商类型';
      this.dialogVisible=true;
    },
    searchBtn(){
      this.page = 1;
      this._customerTypePageList();
    },
    resetBtn(){
      this.nameIpt='';
      this.areaIpt='';
    },
    addBtn(){
      this.dialogTitle='添加委托商类型';
      this.dialogVisible=true;
      this.companyData={
        name:'',
        remark:'',
      };
    },
    addClick(){
      this.companyData=removeSpace(this.companyData,'remark');
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.addLoad = true;
          const obj = {
            id:this.companyData.id,
            typeName:this.companyData.name,
            remark:this.companyData.remark,
          };
          const res = this.dialogTitle==='添加委托商类型'?await customerTypeAdd(obj):await customerTypeUpdate(obj);
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this._customerTypePageList();
          this.dialogVisible=false;
        } else {
          return false;
        }
      });
    },
    enableClick(id){
      this.$confirm('确定要启用当前委托商类型吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await customerTypeIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._customerTypePageList();
      }).catch(() => {});
    },
    dialogClose(){
      this.dialogVisible=false;
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    .unitContainer{
      display: flex;
      align-items:center;
      justify-content:space-between;
      width:140px;
      margin-bottom:5px;
      ::v-deep{
        .el-input__inner{
          border: 1px solid #DCDFE6;
        }
      }
    }
    .unitContainer2{
      display: flex;
      align-items:center;
      justify-content:space-between;
      width:189px;
      margin-bottom:5px;
      span{
        color: #606266;
        font-weight: 700;
      }
      ::v-deep{
        .el-input__inner{
          border: 1px solid #DCDFE6;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
